import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const Logo = ({ imageUrl, logoClass, hidden = false }) => {
  return (
    <div className={`${logoClass ? logoClass : ""}`} style={{
      visibility: hidden ? 'hidden' : 'visible',
      display: 'flex',
      alignItems: 'center',
      marginTop: '-4px',
    }}>
      <Link to={process.env.PUBLIC_URL + "/"}>
        <img alt="logo" src={imageUrl} style={{ maxHeight: '150px', maxWidth: '150px' }} />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string,
  hidden: PropTypes.bool
};

export default Logo;
